import { lazy } from "react";

// const Volunteer = lazy(() => import("@views/Request/Volunteer"))
const Tutor = lazy(() => import("@views/Request/Tutor"))
const Info = lazy(() => import("@views/Request/Tutor/Info"))
// const Club = lazy(() => import("@views/Request/Club"))


const RequestRoutes = [
    // {
    //     path: 'request/volunteer',
    //     element: <Volunteer/>
    // },
    {
        path: 'request/tutor',
        element: <Tutor/>
    },
    // {
    //     path: 'request/club',
    //     element: <Club/>
    // },
    {
        path: 'request/tutor/student/:studentId/info/',
        element: <Info />
    },

]
export default RequestRoutes
